export default "__VITE_ASSET__CbsV0w$8__"